import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Action } from 'src/app/model/gestion/gestion';
import { WebConfigurationService } from '../common/web-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class GestionActionsSavService extends WebConfigurationService {

  constructor(protected http: HttpClient) {
    super(http);
  }

    /**
  * GET the 'actions sav' datas
  * 
  */
     public getActionsSavList(): Observable<any> {
      return this.authGetObs<Action[]>(this.getActionsSavUrl());
    }

      /**
* POST an action sav
* @returns  an Observable
*/
  public postActionSav(newActionSav: Action): Observable<any> {
    return this.http.post<Action>(this.getActionsSavUrl(), newActionSav, {
      headers: this.createHeaders( )
    });
  }

  /** UPDATE action sav */
  public editActionSav(id: number, body: Action) {
    let url = this.getActionsSavUrl() + '/update/' + id;
    return this.authPutObs<Action>(url, body);
  }

  /** DELETE action sav */
  public deleteActionSav(id: number, body : Action) {
    let url = this.getActionsSavUrl() + '/delete/' + id;
    return this.authPutObs<Action>(url, body);
  }


}
